import React from 'react';
import { DollarSign, Calendar, FileText } from 'lucide-react';
import { formatCurrency } from '../../../utils/emendas/statisticsHelpers';
import './StatisticsCard.css';

export default function StatisticsCard({ 
  totalValue, 
  totalCount, 
  yearRange, 
  yearBreakdown,
  selectedYear,
  onYearSelect 
}) {
  return (
    <div className="statistics-card-unified">
      {/* Valor Total */}
      <div className="stat-item stat-item--value">
        <div className="stat-icon stat-icon--green">
          <DollarSign />
        </div>
        <div className="stat-content">
          <span className="stat-label">Valor Total das Emendas</span>
          <span className="stat-value">{formatCurrency(totalValue)}</span>
        </div>
      </div>

      {/* Total de Emendas */}
      <div className="stat-item stat-item--count">
        <div className="stat-icon stat-icon--blue">
          <FileText />
        </div>
        <div className="stat-content">
          <span className="stat-label">Total de Emendas</span>
          <span className="stat-value">{totalCount}</span>
          <span className="stat-subtitle">Todas as emendas</span>
        </div>
      </div>

      {/* Período com Breakdown */}
      <div className="stat-item stat-item--period">
        <div className="stat-icon stat-icon--purple">
          <Calendar />
        </div>
        <div className="stat-content">
          <span className="stat-label">Período</span>
          <span className="stat-value stat-value--small">{yearRange}</span>
          
          {yearBreakdown && yearBreakdown.length > 0 && (
            <div className="year-breakdown">
              {yearBreakdown.map(({ year, count }) => (
                <button
                  key={year}
                  onClick={() => onYearSelect(selectedYear === year ? null : year)}
                  className={`year-chip ${selectedYear === year ? 'year-chip--active' : ''}`}
                  title={`${count} emenda${count !== 1 ? 's' : ''} em ${year}`}
                >
                  <span className="year-chip__year">{year}</span>
                  <span className="year-chip__count">{count}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
